import React ,{Component} from 'react';
import DisplayContactChannels from './../../pages/accountLinking/displayContactChannels';



 class ContactChannels extends Component{
   render(){
     return(

           <div class = "Rectangle-100">

                            
                           <DisplayContactChannels />

           </div>

     );
   }
 }
export default ContactChannels
